"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupMoneyField = void 0;
const formatDollarAmount_1 = require("./formatDollarAmount");
const parseDollarAmount_1 = require("./parseDollarAmount");
function setupMoneyField(input, handler, options = {}) {
    const { defaultValue, noCents, min, max } = options;
    const hasMin = typeof min === "number";
    const hasMax = typeof max === "number";
    const hasDefault = typeof defaultValue === "number";
    const defStr = hasDefault ? (0, formatDollarAmount_1.formatDollarAmount)(defaultValue, noCents) : "";
    // https://discourse.webflow.com/t/custom-attribute-value/28560
    if (hasDefault)
        input.value = defStr;
    input.addEventListener("blur", (e) => {
        const input = e.currentTarget;
        let num = (0, parseDollarAmount_1.parseDollarAmount)(input.value);
        if (hasMin && num < min)
            num = min;
        else if (hasMax && num > max)
            num = max;
        if (isNaN(num)) {
            input.value = defStr;
            return;
        }
        input.value = (0, formatDollarAmount_1.formatDollarAmount)(num, noCents);
        handler(e);
    });
}
exports.setupMoneyField = setupMoneyField;
